<h3>Gerätetausch</h3>

<DataGridView [DataUrl]="dataurl()" #Grid KeyProperty="key">
  <DataGridViewColumn field="key" header="ID" [DataType]="Types.Number" />
  <DataGridViewColumn field="key" [DataType]="Types.Number" >
    <ng-template #cell let-row>
      <input type="checkbox" #VersandCbx class="form-check VersandCbx" [checked]="this.selectedIDs.find(o => o == row.key)" (change)="addOrRemoveID(row.key)" />
    </ng-template>
    <ng-template #header>
      <div class="btn btn-sm btn-primary bi bi-check2-all btn-xs" style=" width: 35px; height: 40px; " tooltip="Alle Auswählen" (click)="SelectAll()">  </div>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn field="userFirstName" header="Vorname" [DataType]="Types.String" />
  <DataGridViewColumn field="userLastName" header="Nachname" [DataType]="Types.String" />
  <DataGridViewColumn field="userPhoneNumber" header="Tel." [DataType]="Types.String" >
    <ng-template #cell let-row>
      <PhoneCall [number]="row.userPhoneNumber" ></PhoneCall>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn field="versichertenMail" header="Mail" [DataType]="Types.String" />
  <DataGridViewColumn field="versicherungsId" header="Versicherten Nr." [DataType]="Types.String" />
  <DataGridViewColumn field="krankenkasseName" header="Kasse" [DataType]="Types.String" />
  <DataGridViewColumn field="kooperationspartnerName" header="Partner" [DataType]="Types.String" />
  <DataGridViewColumn field="austauschAb" header="Austausch Ab" [DataType]="Types.Date" formart="dd.MM.yyyy"  />
  <DataGridViewColumn field="geraetSeriennummerNeu" header="Seriennummer (Neu)" [DataType]="Types.String"   />
  <DataGridViewColumn field="versandTracking" header="Versand" [DataType]="Types.Number" >
    <ng-template #cell let-row>
      <versand-stepper [CurrentStatus]="row.dhlTrackingStatusVersand"></versand-stepper>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn field="versandTracking" header="" [DataType]="Types.Number" >
    <ng-template #cell let-row>
      @if(row.geraetSeriennummerNeu && row.geraetSeriennummerNeu != ''){
        <dhl-controlls [IstVersand]="true" [TrackingNumber]="row.versandTracking"  [AuftragKey]="row.versandAuftrag" [DCOAuftragKey]="row.key" [MailAddress]="row.versichertenMail" [ReloadData]="() => triggerReload()"></dhl-controlls>
      }
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn field="geraetSeriennummerAlt" header="Seriennummer (Alt)" [DataType]="Types.String"  />
  <DataGridViewColumn field="retourenTracking" header="Retoure" [DataType]="Types.Number" >
    <ng-template #cell let-row>
      <versand-stepper [CurrentStatus]="row.dhlTrackingStatusRetoure"></versand-stepper>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn field="versandTracking" header="" [DataType]="Types.Number" >
    <ng-template #cell let-row>
      <dhl-controlls [IstVersand]="false" [TrackingNumber]="row.retourenTracking" [DCOAuftragKey]="row.key" [AuftragKey]="row.retourenAuftrag" [MailAddress]="row.versichertenMail" [ReloadData]="() => triggerReload()"></dhl-controlls>
    </ng-template>
  </DataGridViewColumn>
  <DataGridViewColumn [isFixed]="true" [AllowOrder]="false" [AllowSearch]="false">
    <ng-template #cell let-row>

        <div class="btn btn-sm btn-primary me-1" (click)="SetSerial(row)">
          <i class="fa-solid fa-arrows-turn-to-dots"></i>
        </div>


      <div class="btn btn-sm btn-primary bi bi-pencil-fill" (click)="OpenAkte(row)"></div>
    </ng-template>
    <ng-template #header>

    </ng-template>
  </DataGridViewColumn>
</DataGridView>
<floatingButton icon="bi bi-plus" title="Anlegen" (btnClick)="OpenAkteNew()"></floatingButton>
<floatingButton class="fBtn-1" icon="fa-solid fa-file-arrow-up" title="Export Ausgewählte"  (btnClick)="Export()"></floatingButton>
<floatingButton class="fBtn-2" icon="fa-solid fa-file-arrow-down" title="Export Ausgewählte Retouren" (btnClick)="Export(false)"></floatingButton>
